var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06452 0.25C0.474597 0.25 0 0.751562 0 1.375V3.625C0 4.24844 0.474597 4.75 1.06452 4.75H3.19355C3.78347 4.75 4.25806 4.24844 4.25806 3.625V1.375C4.25806 0.751562 3.78347 0.25 3.19355 0.25H1.06452ZM7.80645 1C7.02137 1 6.3871 1.67031 6.3871 2.5C6.3871 3.32969 7.02137 4 7.80645 4H20.5806C21.3657 4 22 3.32969 22 2.5C22 1.67031 21.3657 1 20.5806 1H7.80645ZM7.80645 8.5C7.02137 8.5 6.3871 9.17031 6.3871 10C6.3871 10.8297 7.02137 11.5 7.80645 11.5H20.5806C21.3657 11.5 22 10.8297 22 10C22 9.17031 21.3657 8.5 20.5806 8.5H7.80645ZM7.80645 16C7.02137 16 6.3871 16.6703 6.3871 17.5C6.3871 18.3297 7.02137 19 7.80645 19H20.5806C21.3657 19 22 18.3297 22 17.5C22 16.6703 21.3657 16 20.5806 16H7.80645ZM0 8.875V11.125C0 11.7484 0.474597 12.25 1.06452 12.25H3.19355C3.78347 12.25 4.25806 11.7484 4.25806 11.125V8.875C4.25806 8.25156 3.78347 7.75 3.19355 7.75H1.06452C0.474597 7.75 0 8.25156 0 8.875ZM1.06452 15.25C0.474597 15.25 0 15.7516 0 16.375V18.625C0 19.2484 0.474597 19.75 1.06452 19.75H3.19355C3.78347 19.75 4.25806 19.2484 4.25806 18.625V16.375C4.25806 15.7516 3.78347 15.25 3.19355 15.25H1.06452Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSolid);
export default __webpack_public_path__ + "static/media/list-solid.1c5dfbad7590c8f653ec5f64eafe4549.svg";
export { ForwardRef as ReactComponent };